import { render, staticRenderFns } from "./JCInstallation.vue?vue&type=template&id=75297395&"
import script from "./JCInstallation.vue?vue&type=script&lang=js&"
export * from "./JCInstallation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports